import { selectCurrentProjectVenue } from '@/domain/project-venue/project-venue.selectors.ts';
import { submitMonthDeclaration } from '@/domain/project-venue-month-declaration/actions/submit-month-declaration.action.ts';
import { selectProjectVenuesMonthDeclaration } from '@/domain/project-venue-month-declaration/project-venue-month-declarations.selectors.ts';
import { createAppAsyncThunk } from '@/domain/store.thunk';

export const reloadMonthDeclarations = createAppAsyncThunk(
  'projectVenueMonthDeclaration/reloadMonthDeclarations',
  async (_, { dispatch, getState }): Promise<void> => {
    const monthDeclarations = selectProjectVenuesMonthDeclaration(getState());
    const projectId = selectCurrentProjectVenue(getState())?.id || -1;
    for (const [month, monthDeclaration] of Object.entries(monthDeclarations)) {
      await dispatch(
        submitMonthDeclaration({ projectId, month, monthDeclaration }),
      );
    }
  },
);
